import React, { useState } from 'react';
import API from '../services/api';
import { 
  Button, 
  Input, 
  Card, 
  Row, 
  Col, 
  Table, 
  Typography, 
  Space,
  Spin,
  message
} from 'antd';
import { SearchOutlined, HistoryOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// 将 Mbps 转换为 Gbps，保留两位小数
const formatGbps = (value) => {
    if (!value) return '0';
    const gbps = parseFloat(value) / 1000;
    return gbps.toFixed(2);
};

const IpTowHistoryLookup = () => {
    const [ip, setIp] = useState('');
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState([]);


    const handleChange = (e) => {
        setIp(e.target.value);
    };

    const handleSubmit = async () => {
        if (!ip.trim()) {
            message.warning('请输入IP地址');
            return;
        }

        setLoading(true);
        setHistory([]);

        try {
            const response = await API.post('/api/admin/ip-tow-history', { ip });
            const historyData = response.data.tow_history || [];
            setHistory(historyData);
            if (historyData.length === 0) {
                message.info('暂无牵引历史记录');
            } else {
                message.success('查询成功');
            }
        } catch (error) {
            message.error(error.response?.data?.message || '查询失败，请稍后再试');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'IP',
            dataIndex: 'ip',
            key: 'ip',
            align: 'center',
            width: 100,
        },
        {
            title: '开始时间',
            dataIndex: 'start_time',
            key: 'start_time',
            align: 'center',
            width: 130,
        },
        {
            title: '结束时间',
            dataIndex: 'end_time',
            key: 'end_time',
            align: 'center',
            width: 130,
        },
        {
            title: '牵引流量(Gbps)',
            dataIndex: 'tow_size',
            key: 'tow_size',
            align: 'center',
            width: 100,
            render: (value) => formatGbps(value),
        },
        {
            title: '牵引包数(pps)',
            dataIndex: 'tow_packet',
            key: 'tow_packet',
            align: 'center',
            width: 100,
        },
        {
            title: '使用套餐',
            dataIndex: 'rule_name',
            key: 'rule_name',
            align: 'center',
            width: 100,
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Row justify="center">
                <Col xs={24} md={16} lg={12}>
                    <Title level={2} style={{ textAlign: 'center', marginBottom: 32 }}>
                        查询 IP 牵引历史
                    </Title>
                    
                    <Card style={{ marginBottom: 32 }}>
                        <Space orientation="vertical" style={{ width: '100%' }} size="large">
                            <div>
                                <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
                                    输入 IP 地址
                                </label>
                                <Space.Compact style={{ width: '100%' }}>
                                    <Input
                                        value={ip}
                                        onChange={handleChange}
                                        placeholder="请输入 IP 地址"
                                        onPressEnter={handleSubmit}
                                        prefix={<SearchOutlined />}
                                    />
                                    <Button 
                                        type="primary" 
                                        onClick={handleSubmit} 
                                        loading={loading}
                                        icon={!loading && <SearchOutlined />}
                                    >
                                        查询
                                    </Button>
                                </Space.Compact>
                            </div>

                            <Text type="secondary" style={{ textAlign: 'center', display: 'block' }}>
                                查询范围：最近 7 天内的牵引记录
                            </Text>
                        </Space>
                    </Card>
                </Col>
            </Row>

            <Row justify="center">
                <Col xs={24} sm={22} md={20} lg={18} xl={16}>
                    <Card 
                        title={
                            <span style={{ color: '#1890ff' }}>
                                <HistoryOutlined style={{ marginRight: 8 }} />
                                牵引历史记录
                            </span>
                        }
                    >
                        <Spin spinning={loading}>
                            <Table
                                columns={columns}
                                dataSource={history}
                                rowKey={(record, index) => index}
                                pagination={false}
                                bordered
                                size="small"
                                scroll={{ x: 600 }}
                                locale={{
                                    emptyText: '暂无牵引历史记录'
                                }}
                            />
                        </Spin>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default IpTowHistoryLookup;